import { PaymentPlanDetailResult } from '@mews-commander/data-access';
import { DataTestId } from '@mews-commander/enums';
import { Dash, EnterpriseLink } from '@mews-commander/ui';

export const PaymentPlanReservationLink = ({
    detail: { reservationId, reservationNumber },
}: {
    detail: PaymentPlanDetailResult;
}) =>
    reservationId && reservationNumber ? (
        <EnterpriseLink
            inherit
            to="Reservation/Detail/$reservationId"
            params={{ reservationId }}
            data-test-id={DataTestId.ReservationLink}
        >
            {reservationNumber}
        </EnterpriseLink>
    ) : (
        <Dash />
    );
